module.exports = __webpack_public_path__ + "img/ocr.4931e6d8.png";